const getColor = (color: string) => {
  switch (color) {
    case "orange":
      return "primary-yellow";
    case "blue":
    case "green":
      return "btn-green-bg"; //Previous blue badge changed to green after reskin. Also, the default badge color
    case "black":
    default:
      return "btn-green-bg"
  }
}

export { getColor };